import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

export default function Table({ columns, data, onSort, sortField, sortDir, emptyMessage = 'Tidak ada data' }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-gray-100">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-50">
            {columns.map(col => (
              <th
                key={col.key}
                className={`table-header text-left ${col.sortable ? 'cursor-pointer select-none hover:bg-gray-100' : ''} ${col.className || ''}`}
                onClick={() => col.sortable && onSort && onSort(col.key)}
              >
                <div className="flex items-center gap-1">
                  {col.label}
                  {col.sortable && (
                    <span className="flex flex-col">
                      <ChevronUp size={10} className={sortField === col.key && sortDir === 'asc' ? 'text-red-600' : 'text-gray-300'} />
                      <ChevronDown size={10} className={sortField === col.key && sortDir === 'desc' ? 'text-red-600' : 'text-gray-300'} />
                    </span>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-12 text-gray-400 text-sm">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr key={row.id || i} className="table-row">
                {columns.map(col => (
                  <td key={col.key} className={`table-cell ${col.className || ''}`}>
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
